import * as actionTypes from "../../Action/actionTypes";

const initialState = {
  subEvent_feedback_table: {
    columns: [
      {
        label: 'Feedback Qusetion',
        field: 'feedback',
        sort: 'asc'
      },
      {
        label: 'Rating',
        field: 'rating',
        sort: 'asc'
      },
      {
        label: 'Participant Ratings',
        field: 'action',
        sort: 'asc'
      },
    ]
  },
  subEvent_participant_feedback_table: {
    columns: [
      {
        label: 'Participant Name',
        field: 'name',
        sort: 'asc'
      },
      {
        label: 'Feedback',
        field: 'feedback',
        sort: 'asc'
      },
      {
        label: 'Participant Ratings',
        field: 'action',
        sort: 'asc'
      },
    ]
  },
  feedback_table_1: {
    columns: [
      {
        label: 'Participant Name',
        field: 'name',
        sort: 'asc'
      },
      {
        label: 'Email',
        field: 'email',
        sort: 'asc'
      },
      {
        label: 'Ratings',
        field: 'rate',
        sort: 'asc'
      },
    ]
  },
  feedback_table_2: {
    columns: [
      {
        label: 'Feedback Question',
        field: 'feedback',
        sort: 'asc'
      },
      {
        label: 'Rating',
        field: 'rate',
        sort: 'asc'
      },
    ]
  },
  speaker_feedback_table: {
    columns: [
      {
        label: 'Speaker Name',
        field: 'speaker_name',
        sort: 'asc'
      },
      {
        label: 'Participant Name',
        field: 'participant_name',
        sort: 'asc'
      },
      {
        label: 'Feedback',
        field: 'feedback',
        sort: 'asc'
      },
      {
        label: 'Rating',
        field: 'rating',
        sort: 'asc'
      }
    ]
  },
  feedback_Question_Array: [
    {
        "session_id": 1,
        "feedback": "text 1",
        "type": "rate",
    },
    {
        "session_id": 1,
        "feedback": "text 2",
        "type": "rate",
    },
    {
        "session_id": 1,
        "feedback": "text 1",
        "type": "rate",
    }
],
  speaker_feedback_Array: [
    {
        "session_id": 1,
        "Speaker_Name" : "Kavindu Akash",
        "feedback": "text 1",
        "type": "rate",
    },
    {
        "session_id": 1,
        "Speaker_Name" : "Kavindu",
        "feedback": "text 2",
        "type": "rate",
    },
    {
        "session_id": 1,
        "Speaker_Name" : "Akash",
        "feedback": "text 1",
        "type": "rate",
    }
  ]
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default reducer;
